import { Defaults } from 'es-decorators'
import { entryScriptName } from 'init/entry-script-name'
import { Collection } from '../components/collection'
import { BankDetails } from 'es6/models/bank-details'

/**
 * Коллекция банковских реквизитов пользователя
 */
@Defaults({
  model: BankDetails,
  url: `${entryScriptName}/api/v3/user-bank-detail/`,
})
export class BankDetailsCollection extends Collection {}
